module.exports = __webpack_public_path__ + "img/brand-desktop-inactive.ab01dfe.svg";